import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { Review } from "@aurelia/types";
import { apiFetch } from "../../lib/api-client";

export function useProductReviews(productId: string | undefined) {
  return useQuery({
    queryKey: ["reviews", productId],
    queryFn: () => apiFetch<{ reviews: Review[] }>(`/reviews/product/${productId}`).then((r) => r.reviews),
    enabled: !!productId
  });
}

export function useCreateReview(productId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: { rating: number; text?: string }) =>
      apiFetch<{ review: Review }>("/reviews", {
        method: "POST",
        body: JSON.stringify({ productId, ...payload })
      }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["reviews", productId] })
  });
}
